export const sections = ['about', 'join'] as const;
export const languages = ['en', 'fr', 'it', 'es', 'el', 'sv', 'ca'] as const;

export type Section = (typeof sections)[number];
export type Language = (typeof languages)[number];
export type SiteLanguages = {
  [Key in (typeof languages)[number]]: string;
};
